// A section read from PostHog (plan step 2.4): not set up yet or down says so in one line of its
// own section (APS-412: the kit's not-configured line, the console's quiet error), and hides
// nothing else on the page.
import { ErrorState as ErrorLine } from '@apsio/ui'
import type { ReactNode } from 'react'
import { NotConfigured } from '../components/kit'
import { useI18n } from '../i18n'

type Section = { status: 'ok' | 'not_configured' | 'unavailable' }

export function PostHogSource({
  section,
  missing,
  children,
}: {
  section: Section
  /** What is not set up, when it is not the read key (the flags tab's write key). */
  missing?: string
  children: ReactNode
}) {
  const { t } = useI18n()
  if (section.status === 'not_configured')
    return (
      <NotConfigured missing={missing ?? t('posthog.notConfigured')} task={t('kit.ownerTask')} />
    )
  if (section.status === 'unavailable') return <ErrorLine message={t('posthog.unavailable')} />
  return <>{children}</>
}
